import React from 'react';

import withPageComponents from '../../../page/components/with-page-components';
import LoyaltyBadge from '../../../product/components/loyalty-badge-v2';
import ProductCTA from '../../../product/components/purchase-button-v2';
import ProductStatusBadge from '../../../product/components/product-status-badge';
import CompareCheckbox from '../../../compare/components/compare-checkbox';
import PaypalBanner from '../../components/pdp-paypal-banner';
import Carepacks from '../carepacks'

import FacebookChatbot from './facebook-chatbot'
import { CompatibleProductsLink } from '../compatible-products';
import { Helpers } from '../../../core/src/helpers';
import './cart-section.less'

const cartSection = ({ product }) => {
    if (product) {
        const { loyalty_multiplier = '0', plcode } = product.attributes || {};
        const showPaypalBanner = Helpers.isProductPC(product) && product.isSmb !== "Yes";
        return (<div id="addtocart" className={'pdp-cart-section'} >
            <CompatibleProductsLink />
            <LoyaltyBadge multiplier={loyalty_multiplier} type={'productCard'} />
            <ProductCTA
                id='pdpAddToCartBtn'
                product={product}
                enableAddToQuote={true}
                templateKey='pdp'
            />
            <CompareCheckbox
                product={product}
                btnText={'Add to compare'}
                selectedText={'Selected to compare'} />
            <Carepacks />
            {showPaypalBanner && <PaypalBanner product={product} />}
            <FacebookChatbot plcode={plcode}/>
            <ProductStatusBadge
                product={product}
                displayShipMessage={true}
                size='large'
            />
        </div>)
    }
    return null;
}

cartSection.whyDidYouRender = true;

export default withPageComponents(cartSection, { components: ['product'] })
